import {
  CREATE_ORDER_REQUEST,
  CREATE_ORDER_SUCCESS,
  CREATE_ORDER_FAILURE,
  GET_ORDER_BY_ID_REQUEST,
  GET_ORDER_BY_ID_SUCCESS,
  GET_ORDER_BY_ID_FAILURE,
  GET_ORDER_HISTORY_REQUEST,
  GET_ORDER_HISTORY_SUCCESS,
  GET_ORDER_HISTORY_FAILURE,
  UPDATE_AWB_REQUEST,
  UPDATE_AWB_SUCCESS,
  UPDATE_AWB_FAILURE,
} from './ActionType';

const initialState = {
  orders: [],
  order: null,
  error: null,
  loading: false,
  updatingAwb: false,
  awbUpdateError: null,
};

export const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ORDER_REQUEST:
    case GET_ORDER_BY_ID_REQUEST:
    case GET_ORDER_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CREATE_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        order: action.payload,
        success: true,
      };

    case GET_ORDER_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        order: action.payload,
      };

    case GET_ORDER_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        orders: action.payload,
      };

    case CREATE_ORDER_FAILURE:
    case GET_ORDER_BY_ID_FAILURE:
    case GET_ORDER_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_AWB_REQUEST:
      return {
        ...state,
        updatingAwb: true,
        awbUpdateError: null,
      };

    case UPDATE_AWB_SUCCESS:
      return {
        ...state,
        updatingAwb: false,
        order: action.payload, // Update order with new awbNo
      };

    case UPDATE_AWB_FAILURE:
      return {
        ...state,
        updatingAwb: false,
        awbUpdateError: action.payload,
      };

    default:
      return state;
  }
};
